import { DateCell } from './table-cells';

type ModifiedRowInfoProps = {
    row: {
        modifiedAt?: Date | string;
        modifiedBy?: string;
    };
};
export const ModifiedRowInfo = ({ row }: ModifiedRowInfoProps) => {
    return (
        <div className="d-flex gap-1">
            <div>{row.modifiedBy}</div>
            {row.modifiedAt && row.modifiedBy && <div>@</div>}
            <DateCell value={row.modifiedAt} />
        </div>
    );
};
